export default {
  not_authorized: "Vous n'êtes pas autorisé à accéder à cette page"
}
